import React from 'react'
import { ConvertedRealEstate } from '../../../../../../../../../@types/real-estate-api-types'
import { IconS24Building424 } from '@is24/cosma-ui-icons'

interface RealEstateObjectAddressProps {
  object: ConvertedRealEstate
}

export function RealEstateObjectAddressTitle(props: RealEstateObjectAddressProps) {
  const listening = props.object.listing
  return (
    <div className='grid grid-flex gutter-xs padding-horizontal-s' data-testid={'object-item-testid'}>
      <IconS24Building424 />
      <TitleItem bold value={listening.street} />
      <TitleItem bold value={listening.houseNumber} />
      <TitleItem value={listening.postcode} />
      <TitleItem value={listening.city} />
    </div>
  )
}

function TitleItem(props: { bold?: true; value?: string }) {
  if (!props.value) {
    return undefined
  }
  return (
    <div className={`grid-item ${props.bold ? 'font-body-medium-bold' : 'font-body-medium-regular'}`}>
      {props.value}
    </div>
  )
}
